module.exports = __webpack_public_path__ + "static/fonts/iconfont.8c46e5f1.ttf";